import(/* webpackMode: "eager" */ "/app/components/CookieConsent/CookieConsentView.tsx");
import(/* webpackMode: "eager" */ "/app/components/CouponBar/CouponBar.tsx");
import(/* webpackMode: "eager" */ "/app/lib/apollo/ApolloWrapper.tsx");
import(/* webpackMode: "eager" */ "/app/node_modules/@react-oauth/google/dist/index.esm.js");
import(/* webpackMode: "eager" */ "/app/utils/providers/LanguageSwitcherProvider/LanguageSwitcherProvider.tsx")